// extracted by mini-css-extract-plugin
export default {"main":"Wrapper_main__pzTis","row":"Wrapper_row__dQyvj","col":"Wrapper_col__UMU4-"};